import { t } from 'i18next';
import { Role } from '../../../contexts/LicenseManagementContext/LicenseManagementContext.types';

export const AUTHOR_ROLE_NAME = 'BbDataAuthor';
export const VIEWER_ROLE_NAME = 'BbDataReportViewer';
export const ADMIN_ROLE_NAME = 'InstitutionAdmin';
export const RESTRICTED_VIEWER_ROLE_NAME = 'BbDataRestrictedViewer';
export const DEVELOPER_ROLE_NAME = 'BbDataDeveloper';

export const VISIBLE_ROLES = [
    AUTHOR_ROLE_NAME,
    VIEWER_ROLE_NAME,
    ADMIN_ROLE_NAME,
    RESTRICTED_VIEWER_ROLE_NAME,
    DEVELOPER_ROLE_NAME,
] as const;

export const ROLES_WITH_QS_ACCESS = [
    VIEWER_ROLE_NAME,
    AUTHOR_ROLE_NAME,
    ADMIN_ROLE_NAME,
    RESTRICTED_VIEWER_ROLE_NAME,
] as const;

export const ROLE_PRIORITY: { [role: string]: number } = {
    // lower number = shows earlier on the list of user roles
    [ADMIN_ROLE_NAME]: 1,
    [AUTHOR_ROLE_NAME]: 2,
    [DEVELOPER_ROLE_NAME]: 3,
    [VIEWER_ROLE_NAME]: 4,
    [RESTRICTED_VIEWER_ROLE_NAME]: 5,
};

export const translateUserRoles = (roles: Role[] | undefined): string =>
    [
        ...new Set(
            (roles || [])
                .filter(r => VISIBLE_ROLES.includes(r.name as any))
                .sort(
                    (a, b) =>
                        (ROLE_PRIORITY[a.name] || Number.MAX_SAFE_INTEGER) -
                        (ROLE_PRIORITY[b.name] || Number.MAX_SAFE_INTEGER),
                )
                .map(({ name }) =>
                    name === RESTRICTED_VIEWER_ROLE_NAME
                        ? VIEWER_ROLE_NAME
                        : name,
                )
                .map(name => t(`settings.illuminateRoles.${name}.displayName`)),
        ),
    ].join(', ') || t('settings.licenseManagement.unknownRole');
